import React from 'react';
import {Route} from "react-router";
import {compArr} from "../selectors";
import {compose} from "redux";
import {connect} from "react-redux";
import {PathBreadcrumbItem, withBreadcrumbCurried} from "../../Boilerplate/BreadcrumbContext";
import {withLoading404} from "../../Boilerplate/deferLoaderHoc";
import {setViewPath} from "../../../actions/view";
import {getPunchList} from "../../../actions/punchList";
import PunchListDetail from "./PunchListDetail";
import PunchListEdit from "./PunchListEdit";

class PunchList extends React.PureComponent {
  render() {
    return (
      <div>
        <Route exact path="/projects/:id/punch-list/:punchListId" component={PunchListDetail}/>
        <Route path="/projects/:id/punch-list/:punchListId/edit" component={PunchListEdit}/>
      </div>
    );
  }
}

const PunchListBreadcrumb = props => PathBreadcrumbItem({ path: `/projects/${props.match.params.id}/punch-list/`, resource: props.punchList.resource });

export default compose(
  connect(
    (state, props) => {
      const projectId = props.match.params.id;
      const punchList = state.view.subview.data[props.match.params.punchListId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'punches', props.match.params.punchListId];
      if (!compArr(path, itempath) || loading || !punchList) return { loading: true };
      return { punchList, projectId };
    },
    (dispatch, props) => ({
      preload: () => dispatch(setViewPath(['projects', props.match.params.id, 'punches', props.match.params.punchListId])),
      loader: () => dispatch(getPunchList(props.match.params.id, props.match.params.punchListId)),
    })),
  withLoading404,
  withBreadcrumbCurried(PunchListBreadcrumb),
)(PunchList);



// WEBPACK FOOTER //
// ./src/components/Projects/PunchList/PunchList.js